

export const TiposOperacoes = [
    'Projeto',
    'Serrote',
    'Convencionais',
    'CNC',
    'Acabamento',
    'Tratamento',
    'Controlo e Qualidade',
    'Expedição',
];